module.exports = __webpack_public_path__ + "img/hire3x.db89fbcf.svg";